import { ShieldOff } from 'lucide-react';

export const LicenseExpiredScreen = () => (
  <div className="flex min-h-screen items-center justify-center bg-slate-950 px-6 text-white" data-testid="license-expired-screen">
    <div className="max-w-md text-center" style={{ animation: 'fadeInUp .5s ease both' }}>
      <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-orange-500/15 text-orange-400"><ShieldOff className="h-8 w-8" /></span>
      <h1 className="mt-6 text-3xl font-bold" data-testid="license-expired-title">Lisansınız sona erdi</h1>
      <p className="mt-3 text-base text-slate-400">Sisteme erişim geçici olarak kapatılmıştır. Lisansınızı yenilemek için lütfen bizimle iletişime geçin.</p>
      <a href="mailto:info@permit.com" className="mt-8 inline-flex rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold transition-colors hover:bg-orange-600" data-testid="license-expired-contact">info@permit.com</a>
    </div>
  </div>
);
